'use client';
import React from 'react';
import AdsBlock from '../adsBlock/AdsBlock';
import { MainWrapper } from '@/components/ui/box/MainWrapper';
import AssociatedFunds from './AssociatedFunds/AssociatedFunds';
import AssociatedCompanies from './AssociatedCompanies/AssociatedCompanies';
import PersonalInvestments from './PersonalInvestments/PersonalInvestments';

function Overview({ onePerson, isLogin }) {
  return (
    <>
      <AssociatedCompanies {...{ onePerson }} />
      <AssociatedFunds {...{ onePerson }} />

      <PersonalInvestments {...{ onePerson }} />
      <MainWrapper
        customStyleOuter={{
          px: { base: '8px', md: '40px', xl: '0' },
          mt: { base: '40px', md: '60px' },
        }}
        customStyleInner={{
          maxW: { base: '100%', md: '100%', xl: '1124px' },
        }}
      >
        {!isLogin ? <AdsBlock /> : null}
      </MainWrapper>
    </>
  );
}

export default Overview;

export function PersonOverviewWrapper({ children, customStyleInner }) {
  return (
    <MainWrapper
      customStyleOuter={{
        px: { base: '8px', md: '40px', xl: '0' },
        mt: { base: '40px', md: '60px' },
      }}
      customStyleInner={{
        bgColor: 'white',
        borderRadius: '10px',
        py: '20px',
        flexDirection: 'column',
        className: 'hide-scrollbar',
        maxW: { base: '100%', md: '100%', xl: '1124px' },
        ...customStyleInner,
      }}
    >
      {children}
    </MainWrapper>
  );
}
